<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">楼栋名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">层均面积：</span>
        </div>
        <el-input v-model="formData.perFloorArea" size="small" style="width: 280px" disabled>
          <template slot="append">m²</template>
        </el-input>
      </div>
      <div class="form-line" style="display: flex;justify-content: flex-start">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">楼层配置：</span>
        </div>
        <div style="line-height: 32px;margin-left: 3px;">
          <el-radio v-model="buildingConfig" label="1">单独添加</el-radio>
          <el-radio v-model="buildingConfig" label="2">批量连续添加</el-radio>
        </div>
      </div>
      <div v-if="buildingConfig === '1'" style="max-height: 450px;overflow-y: auto;">
        <div class="form-line" v-for="(item, index) in buildConfigList" :key="index.toString()">
          <div class="textBox">
            <b class="red" v-if="index === 0">*</b>
            <span class="line-text" v-if="index === 0">楼层序号：</span>
          </div>
          <el-input v-model="item.floorsNo" size="small" style="width: 280px" />
          <i class="el-icon-remove-outline" style="font-size: 24px;color: #f25721;line-height: 32px;margin: 0 0 0 10px; cursor: pointer" @click="removeBuildConfig(index)" v-if="index !== 0"></i>
          <i class="el-icon-circle-plus-outline" style="font-size: 24px;color: #00A0E6;line-height: 32px;margin: 0 10px; cursor: pointer" @click="addBuildConfig(index)" v-if="index === buildConfigList.length -1"></i>
        </div>
      </div>
      <div v-if="buildingConfig === '2'">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">楼层序号：</span>
          </div>
          <div>
            <el-input-number v-model="formData.startFloor" controls-position="right" :min="-10" :max="300" size="small" style="width: 135px" />
            ~
            <el-input-number v-model="formData.endFloor" controls-position="right" :min="-10" :max="300" size="small" style="width: 135px" />
          </div>
        </div>
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {api} from '../../api/HousingManagement'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'housing-building-modify',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '房屋管理'
        }],
        mainTitle: '修改楼栋',
        subheading: '修改楼栋信息',
        buildingConfig: '1',
        buildConfigList: [
          {
            floorsNo: '',
          }
        ],
        formData: {
          name: '',
          perFloorArea: '',
          startFloor: '0',
          endFloor: '0',
          floorsNo: ''
        }
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getBuildingByCode()
    },
    methods: {
      toHousingManagement () {
        this.$router.push({
          name: 'housing-management'
        })
      },
      addBuildConfig(index) {
        let hasFloor = false
        for (let i = 0; i < this.buildConfigList.length-1; i++) {
          if (this.buildConfigList[i].floorsNo === this.buildConfigList[index].floorsNo) {
            hasFloor = true
          }
        }
        if (this.buildConfigList[index].floorsNo >= this.formData.startFloor && this.buildConfigList[index].floorsNo <= this.formData.endFloor) {
          this.buildConfigList[index].floorsNo = ''
          nError('该楼层已在连续添加中')
          return
        }
        if (hasFloor) {
          this.buildConfigList[index].floorsNo = ''
          nError('请勿输入重复楼层')
          return
        }
        if (!this.buildConfigList[index].floorsNo) {
          nError('请先输入当前需要添加的楼层')
          return
        } else {
          let obj = {
            floorsNo: '',
          }
          this.buildConfigList.push(obj)
        }
      },
      removeBuildConfig (index) {
        this.buildConfigList.splice(index, 1)
      },
      getBuildingByCode () {
        this.$axios.get(`${api.getBuildingByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
              if (this.formData.floorsNo) {
                this.buildConfigList = []
                let floorsNoArr = this.formData.floorsNo.split(',')
                floorsNoArr.map(v => {
                  let obj = {
                    floorsNo: v,
                  }
                  this.buildConfigList.push(obj)
                })
              } else {
                this.buildConfigList = [
                  {
                    floorsNo: '',
                  }
                ]
              }
            }
          })
          .catch(errorHandler('获取楼栋信息失败'))
      },
      confirm () {
        if (!this.formData.name) {
          nError('请输入楼栋名称')
          return false
        }
        if (!this.formData.perFloorArea) {
          nError('请输入楼栋每层面积')
          return false
        }
        if (this.formData.startFloor != 0 && this.formData.endFloor != 0 && this.formData.startFloor === this.formData.endFloor) {
          nError('批量添加楼层起止序号不允许相同')
          return false
        }
        let floorsNoArr = []
        let floorsNoState = 0
        this.buildConfigList.map(v => {
          if ((parseInt(v.floorsNo) > parseInt(this.formData.startFloor) || parseInt(v.floorsNo) === parseInt(this.formData.startFloor)) && (parseInt(v.floorsNo) < parseInt(this.formData.endFloor) || parseInt(v.floorsNo) === parseInt(this.formData.endFloor))) {
            floorsNoState = floorsNoState + 1
          }
          if (v.floorsNo != 0 ) {
            floorsNoArr.push(v.floorsNo)
          }
        })
        // if (floorsNoState > 0) {
        //   nError(`连续添加楼层包含单独添加楼层`)
        //   return false
        // }
        this.formData.floorsNo = floorsNoArr.join(',')
        if (!this.formData.floorsNo && (!this.formData.startFloor || !this.formData.endFloor)) {
          nError('请输入楼层配置')
          return false
        }
        let yqCode = window.sessionStorage.getItem('buildingyqCode')
        this.formData.yqCode = yqCode
        this.$axios.post(api.updateBuilding, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toHousingManagement()
            }
          })
          .catch(errorHandler('修改楼栋失败'))
      },
      cancel () {
        this.toHousingManagement()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    line-height: 32px;
    flex-wrap: wrap;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/HousingManagement/HousingBuildingModify.vue